"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardBlockedSendersOption_1 = require("./actions/discardBlockedSendersOption");
var saveBlockedSendersOption_1 = require("./actions/saveBlockedSendersOption");
var BlockedSendersFull_1 = require("./components/BlockedSendersFull");
var isBlockedSendersOptionDirty_1 = require("./utils/isBlockedSendersOptionDirty");
var React = require("react");
var BlockedSendersOption = {
    key: 'blockedSenders',
    titleStringKey: 'optionTitle_blockedSenders',
    searchTermsStringKey: 'optionSearchTerms_blockedSenders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(BlockedSendersFull_1.default, null); },
        isDirty: isBlockedSendersOptionDirty_1.default,
        onSave: saveBlockedSendersOption_1.default,
        onDiscard: discardBlockedSendersOption_1.default,
    },
};
exports.default = BlockedSendersOption;
//# sourceMappingURL=BlockedSendersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-senders-option/lib/BlockedSendersOption.js
// module id = 5033
// module chunks = 2